import { PropsWithChildren } from 'react'
import Styles from './Account.module.scss'

export const AccountsList = ({ children }: PropsWithChildren) => <ul className={Styles.linkedAccounts}>{children}</ul>
